import { Snippet as NSnippet, type SnippetProps as Props } from '@heroui/react';

type SnippetProps = Props & { size?: 'sm' | 'md' | 'lg'; color?: string };

export const Snippet = ({ children, ...props }: SnippetProps) => {
  return <NSnippet {...props}>{children}</NSnippet>;
};
